import { fetchApi } from '@/config/api';
import type { InvitationResult, EmailLog } from '@/types';

/**
 * Envoie des invitations d'acheteurs via CSV
 */
export async function sendInvitations(csvContent: string): Promise<InvitationResult> {
  const mutation = `
    mutation UploadInvitationsCsv($csvContent: String!) {
      uploadInvitationsCsv(csvContent: $csvContent) {
        success
        totalProcessed
        successful
        failed
        errors {
          email
          error
        }
      }
    }
  `;

  const result = await fetchApi<{ uploadInvitationsCsv: InvitationResult }>(
    mutation,
    { csvContent }
  );

  return result.uploadInvitationsCsv;
}

/**
 * Récupère l'historique des invitations envoyées
 */
export async function getInvitationHistory(limit = 50): Promise<EmailLog[]> {
  const query = `
    query GetInvitationHistory($limit: Float!) {
      getInvitationHistory(limit: $limit) {
        id_email_log
        id_email
        page
        email_from
        email_to
        date_envoi
      }
    }
  `;

  const result = await fetchApi<{ getInvitationHistory: EmailLog[] }>(
    query,
    { limit }
  );

  return result.getInvitationHistory;
}

/**
 * Récupère l'aperçu HTML de l'email
 */
export async function getEmailPreview(language = 'fr'): Promise<string> {
  const query = `
    query GetEmailPreview($language: String!) {
      getEmailPreview(language: $language)
    }
  `;

  const result = await fetchApi<{ getEmailPreview: string }>(query, { language });
  return result.getEmailPreview;
}

/**
 * Envoie une invitation unique (même template que la page promotionalemail)
 */
export async function sendSingleInvitation(email: string, language: 'fr' | 'en' = 'fr') {
  const mutation = `
    mutation SendSingleInvitation($email: String!, $language: String) {
      sendSingleInvitation(email: $email, language: $language) {
        success
        totalProcessed
        successful
        failed
        errors { email error }
      }
    }
  `;

  const result = await fetchApi<{ sendSingleInvitation: any }>(mutation, { email, language });
  return result.sendSingleInvitation;
}


